/*
 * Custom JavaScript
 * ===========================================================================
 *
 * Use this file to add your own custom JavaScript code.
 *
 * This file is loaded at the end of the body with the 'defer' attribute,
 * which means it will execute after the HTML document has been parsed.
 *
 * Tips:
 * - The DOM is ready when this script runs (no need for DOMContentLoaded)
 * - You can use Shopify's global objects like:
 *   - window.Shopify - Shopify global object with shop info
 *   - window.routes - Cart and search URLs
 *   - window.cartStrings - Cart-related translation strings
 *   - window.variantStrings - Product variant translation strings
 *
 * - The theme uses a pub/sub pattern for events. You can subscribe to events:
 *   - subscribe(PUB_SUB_EVENTS.cartUpdate, callback) - Cart updates
 *   - subscribe(PUB_SUB_EVENTS.quantityUpdate, callback) - Quantity changes
 *
 * - Common DOM queries:
 *   - document.querySelector('.selector') - Get single element
 *   - document.querySelectorAll('.selector') - Get all matching elements
 *
 * ===========================================================================
 */

/* Add your custom JavaScript below this line */

// Keep all visible product titles on two centered lines, including Ajax results.
(() => {
  const selector = '.sm-product-title-lines';
  const observed = new WeakSet();
  const widths = new WeakMap();
  const pending = new Set();
  let frame = 0;

  function fit(title) {
    if (!title.isConnected || title.clientWidth < 1) return;
    title.style.fontSize = '';
    const available = title.clientWidth;
    const natural = Math.max(...Array.from(title.children, line => line.scrollWidth));
    if (natural > available) {
      const size = parseFloat(getComputedStyle(title).fontSize);
      title.style.fontSize = `${Math.floor(size * available / natural * 98) / 100}px`;
    }
  }

  function schedule(title) {
    pending.add(title);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      pending.forEach(fit);
      pending.clear();
    });
  }

  const resize = new ResizeObserver(entries => {
    entries.forEach(({ target, contentRect }) => {
      if (Math.abs((widths.get(target) || 0) - contentRect.width) > 0.5) {
        widths.set(target, contentRect.width);
        schedule(target);
      }
    });
  });

  function register(title) {
    if (observed.has(title)) return;
    observed.add(title);
    resize.observe(title);
    schedule(title);
  }

  function formatGuide(heading) {
    if (heading.querySelector(selector)) return;
    const parts = heading.textContent.trim().split(/ [–—-] /);
    const range = parts.length > 1 ? parts.pop().trim() : '';
    const title = document.createElement('span');
    title.className = 'sm-product-title-lines';
    const type = document.createElement('span');
    type.className = 'sm-product-title-lines__type';
    type.textContent = parts.join(' – ').trim();
    const rangeLine = document.createElement('span');
    rangeLine.className = 'sm-product-title-lines__range';
    rangeLine.textContent = range;
    title.append(type, document.createTextNode(' '), rangeLine);
    heading.replaceChildren(title);
    register(title);
  }

  function discover(node) {
    if (!(node instanceof Element)) return;
    if (node.matches('.sg-product h4')) formatGuide(node);
    node.querySelectorAll('.sg-product h4').forEach(formatGuide);
    if (node.matches(selector)) register(node);
    node.querySelectorAll(selector).forEach(register);
  }

  discover(document.body);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(discover));
  }).observe(document.body, { childList: true, subtree: true });
  const refresh = () => document.querySelectorAll(selector).forEach(schedule);
  window.addEventListener('resize', refresh, { passive: true });
  if (document.fonts) document.fonts.ready.then(refresh);
})();
